export const validateTextField = (text: string | null) => {
  if (text?.trim()?.length === 0) {
    return 'evidence.attribute.required';
  }
};
